import ConnectionTest from '../components/DevicesTest/ConnectionTest';
import SpeakerTest from '../components/DevicesTest/SpeakerTest';
import WebcamTest from '../components/DevicesTest/WebcamTest';
import MicrophoneTest from '../components/DevicesTest/MicrophoneTest/MicrophoneTest';

import { StepsContentType } from '@core/myta/constants/interfaces';

export enum STEP_TESTS {
  CONNECTION = 'connection',
  MICROPHONE = 'microphone',
  SPEAKER = 'speaker',
  WEBCAM = 'webcam',
}

export const STEPS_CONTENT: StepsContentType[] = [
  () => ({ stepTest: STEP_TESTS.CONNECTION, content: <ConnectionTest /> }),
  () => ({ stepTest: STEP_TESTS.MICROPHONE, content: <MicrophoneTest /> }),
  () => ({ stepTest: STEP_TESTS.SPEAKER, content: <SpeakerTest /> }),
  () => ({ stepTest: STEP_TESTS.WEBCAM, content: <WebcamTest /> }),
];

export const DEVICES_TEST_STEPS_COUNT = STEPS_CONTENT.length;
